import React, { FC } from 'react'

import { IconRatingsOrFavouriteProps } from './IconRatingsOrFavourite.types'
import * as Styled from './styles/IconRatingsOrFavourite.style'

import { nonThemeableRules } from '../../ruleSet'

const IconRatingsOrFavourite: FC<IconRatingsOrFavouriteProps> = ({
  size = nonThemeableRules.defaultSize as number as IconRatingsOrFavouriteProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconRatingsOrFavouriteProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M159.77 58.65A4 4 0 0 0 156 56h-54.78L83.8 2.76A4 4 0 0 0 80 0a4 4 0 0 0-3.78 2.7L57.83 56H4a4 4 0 0 0-2.57 7.06l43 36.16L27 154.8a4 4 0 0 0 6.17 4.43l46.83-34 46.83 34a4 4 0 0 0 6.15-4.49L114.6 99.23l43.94-36.14a4 4 0 0 0 1.23-4.44zM107.4 94.79a4 4 0 0 0-1.26 4.35l15.33 46.32L82.35 117a4 4 0 0 0-4.71 0l-39.38 28.64 14.61-46.56a4 4 0 0 0-1.24-4.26L15 64h45.68a4 4 0 0 0 3.78-2.7L79.9 16.56l14.62 44.68a4 4 0 0 0 3.8 2.76h46.52z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconRatingsOrFavourite
